export default __webpack_public_path__ + "static/media/app-screens-v2-67-2_06.d7e13254.jpg";